import { font } from '~/app/parent/header/font';
import { leaflet, leafletRoutingMachine } from '~/app/parent/header/leaflet';
import { style } from '~/app/parent/header/style';
import { userlane } from '~/app/parent/header/userlane';
import { documentAvailable } from '~/utils/client-detection';

let isParentInjected = false;

export function injectParent() {
	if (isParentInjected) return;
	isParentInjected = true;

	const head = documentAvailable() ? document.head || document.getElementsByTagName('head')[0] : undefined;

	font && head?.appendChild(font);
	style && head?.appendChild(style);

	// In development mode, we don't need to load the CSS file from an external source
	if (!process.env.IS_VITE_DEV) {
		const appStylesLink = document?.createElement('link');
		appStylesLink.rel = 'stylesheet';
		appStylesLink.type = 'text/css';
		appStylesLink.href = 'https://d1p8elq7q5x0x6.cloudfront.net/ngc/styles.css';
		document?.head.appendChild(appStylesLink);
	}

	leaflet && head?.appendChild(leaflet);
	leafletRoutingMachine && head?.appendChild(leafletRoutingMachine);
	userlane && head?.appendChild(userlane);
}
